import { VIDEO_PREVIEW_MODE } from '../../campaigns/modules/common-campaign-form/config/VideoPreviewMode';
import { MACROS_NAMES } from '../../campaigns/modules/video-campaigns-form/components/VideoCreativeCreatorPreview/macrosConstants';

const liteUnitUrlRaw = 'https://vidstat.taboola.com/lite-unit/{liteUnitVersion}/UnitInlineDesktop.min.js';

class Init {
    lastVast;

    _loadLiteUnit(liteUnitUrl) {
        return new Promise((resolve, reject) => {
            const liteUnitTag = document.createElement('script');
            liteUnitTag.async = false;
            liteUnitTag.src = liteUnitUrl;
            liteUnitTag.id = 'ta-lu-script';
            liteUnitTag.onload = () => {
                this.videoUnitLoaded = true;
                resolve();
            };
            liteUnitTag.onerror = () => {
                reject(new Error('Failed to load lite unit'));
            };
            document.head.appendChild(liteUnitTag);
        });
    }

    clearVideoPlacement(placementRef) {
        if (!this.videoUnitLoaded) {
            return;
        }

        if (placementRef.current) {
            placementRef.current.innerHTML = '';
        }
        this.lastVast = null;
    }

    async loadUnit(containerId, vast, adNativeSettings, macros, previewMode, onVideoLoaded = () => {}) {
        if (this.lastVast === vast) {
            return;
        }

        if (!this.videoUnitLoaded) {
            const liteUnitUrl = liteUnitUrlRaw.replace('{liteUnitVersion}', macros[MACROS_NAMES.LITE_UNIT_VERSION]);
            try {
                await this._loadLiteUnit(liteUnitUrl);
            } catch (error) {
                throw new Error('Failed to load lite unit');
            }
        }

        // eslint-disable-next-line no-eval
        const unit = eval(
            previewMode === VIDEO_PREVIEW_MODE.DESKTOP
                ? macros[MACROS_NAMES.PREVIEW_CONF_DESKTOP]
                : macros[MACROS_NAMES.PREVIEW_CONF_MOBILE]
        );

        const videoSelector = `#${containerId}`;
        unit.set('parentSelector', videoSelector);
        unit.set('demandConfig.waterfall.tags', [
            {
                vast,
                sa: 1,
                nas: adNativeSettings,
            },
        ]);

        unit.on('filledImpression', onVideoLoaded);

        this.lastVast = vast;
    }

    setNativeAdSettings(nativeAdSettings) {
        window.setPreviewAdSettings && window.setPreviewAdSettings(nativeAdSettings);
    }
}

export default new Init();
